export default __webpack_public_path__ + "static/media/sad.c17a6eaf.webp";